import React, { useCallback, useEffect, useState } from "react";

import { PageLoading } from "@/components/PageLoading";
import { useRouter } from "@/hooks/useRouter";

import { useAuthContext } from "../hooks/useAuthContext";

const loginPaths: Record<string, string> = {
  jwt: "/auth/one-id",
};

type Props = {
  children: React.ReactNode;
};

export function AuthGuard({ children }: Props) {
  const { loading } = useAuthContext();

  return loading ? <PageLoading /> : <Container>{children}</Container>;
  // return <Container>{children}</Container>;
}

function Container({ children }: Props) {
  const router = useRouter();

  const { authenticated, method } = useAuthContext();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated) {
      const searchParams = new URLSearchParams({
        returnTo: window.location.pathname,
      }).toString();

      const loginPath = loginPaths[method];

      const href = `${loginPath}?${searchParams}`;

      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [authenticated, method, router]);

  useEffect(() => {
    check();
  }, []);

  if (!checked) {
    return null;
  }

  return children;
}
